import React, { lazy, Suspense } from 'react';

const Load = lazy(
  () =>
    // eslint-disable-next-line
    new Promise<any>((resolve) => {
      import('./make-payment').then((component) => {
        resolve(component);
      });
    })
);

export function MakePaymentLazy() {
  return (
    <Suspense
      fallback={
        <div className="loading-logo">
          {/*<img className="loading-logo-size" src="/assets/images/loading.gif" alt="a" /> */}
        </div>
      }
    >
      <Load />
    </Suspense>
  );
}
export default MakePaymentLazy;
